/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const DestinationType = zod.enum(['webhook', 'callback']);

export type DestinationType = zod.input<typeof DestinationType>;
export type DestinationTypeOutput = zod.output<typeof DestinationType>;
